import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import parseRecordsForTable from "components/ProjectSpecificComponents/Functions/parseRecordsForTable"
import { IRequestTableFormField } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import {
	IRequestTableData,
	TSubmitRequest,
} from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import {
	TOnClickTableRow,
	TTableHeadCell,
} from "components/ProjectSpecificComponents/Interfaces/TableInterface"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import FormFieldLabel from "../../AdminForm/atoms/FormFieldLabel"
import { Td } from "./Table/StyledComponents/TableStyleComp"
import Table from "./Table/Table"
import { TSortConfig } from "./Table/Interfaces/Interfaces"
import { observer } from "mobx-react-lite"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import i18n from "i18n"

interface Props {
	config: IRequestTableFormField[]
	records?: IRequestTableData[] | undefined
	onClickRow?: TOnClickTableRow
}

const RequestTableFormFieldTable = observer(({ config, records, onClickRow }: Props) => {
	const { t } = useTranslation()
	const formStore = useFormStore()
	const [defaultSortOrder, setDefaultSortOrder] = useState<TSortConfig | undefined>()
	// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
	const isEN = i18n.language === "en"

	const head: TTableHeadCell[] = config.map(
		({ nameLV, nameEN, mainFieldKey, mainFieldLabel, searchable, sortable, type }) => {
			return {
				key: mainFieldKey,
				type: type,
				label: isEN ? nameEN ?? mainFieldLabel : nameLV ?? mainFieldLabel, // If admin doesn't specify name, takes Jama name
				// !TECHNICAL DEBT-2143: Add <Table /> functionality: takes `searchable` by each column
				searchable: searchable,
				// !TECHNICAL DEBT-2143: Add <Table /> functionality: takes `sortable` by each column
				sortable: sortable,
			}
		}
	)
	/**
	 * Find if any of table columns is set to be default sort
	 */
	const getDefaultSortOrder = () => {
		config.find(({ isDefaultSortField, mainFieldKey, defaultSortOrder, type }) => {
			if (isDefaultSortField && defaultSortOrder) {
				setDefaultSortOrder({ key: mainFieldKey, direction: defaultSortOrder, type: type })
			}
		})
	}

	useEffect(() => {
		getDefaultSortOrder()
	}, [])
	// Used to access value directly without looping through head
	// ! TO DO: Head should be remade to object
	const headAsObject = () => {
		var initHead: any = {}
		head.map((value) => (initHead[value.key] = value))
		return initHead
	}

	const TableRow = (row: any) =>
		records &&
		records.length > 0 &&
		config.map(({ mainFieldKey }) => (
			<Td>
				<HyperDiv
					className="hide-overflown-text-nowrap w-fit-content"
					padding="5px"
					style={{
						backgroundColor: row[`${mainFieldKey}-color`]
							? `#${row[`${mainFieldKey}-color`]}`
							: undefined,
						borderRadius: "5px",
						maxWidth: "100%",
					}}
				>
					{row[mainFieldKey].toString()}
				</HyperDiv>
			</Td>
		))
	/**
	 * Checks if all required fields for table exists
	 * If not then add that field with empty value
	 */
	const makeSureAllRequiredFieldsExist = () => {
		records?.map(({ fields }) => {
			head.map(({ key }) => {
				const emptyField: TSubmitRequest = { fieldId: key, value: "", color: null }
				// If field doesnt exist that is required for table then add field with empty value
				if (!fields.some(({ fieldId }) => fieldId === key)) {
					fields.push(emptyField)
				}
			})
		})
		return records || []
	}

	const bigLogo = formStore.settingsData.personalize

	return (
		<>
			{head.length > 0 && (
				<Table
					scrollRecords={{
						set: true,
						bodyHeight: bigLogo ? "calc(100vh - 430px)" : "calc(100vh - 360px)",
					}}
					search
					head={head}
					records={
						records ? parseRecordsForTable(makeSureAllRequiredFieldsExist(), headAsObject()) : [{}]
					} // is empty; doesn't matter => just showing dots
					tableRow={TableRow}
					clickedOnRow={onClickRow}
					fixedColumnWidth
					defaultSortOrder={defaultSortOrder}
				/>
			)}

			{head.length === 0 && (
				<HyperDiv centered>
					<Whitespace x="3" />
					<p>{t("table.noConfig")}</p>
				</HyperDiv>
			)}
		</>
	)
})

export default RequestTableFormFieldTable
